import React from "react";
import journeyImg from "../../../assets/images/ourjourney.png";
import journeyImg2 from "../../../assets/images/ourjourney2.png"; // adjust path as needed
const awards = [
  {
    year: "2011",
    title: "Pravasi Bharathi Shreyas Award",
  },
  {
    year: "2011",
    title: "Voice of Gulf Returnees Award",
  },
  {
    year: "2012",
    title: "Golden Achievement Award (Dubai)",
  },
  {
    year: "2014",
    title: "Pravasi Bharati Manavaseva Puraskaram",
  },
  {
    year: "2016",
    title: "Dr. B.R. Ambedkar Baba Saheb National Award",
  },
];
export const JourneyAndAwards: React.FC = () => (
  // <section className="bg-white p-8 rounded shadow max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
  //   <div>
  //     <h2 className="text-xl font-semibold mb-1">Our Journey</h2>
  //     <h3 className="text-red-600 text-lg font-bold mb-4">Since 1992</h3>

  //     <div className="space-y-2 mb-6">
  //       <div className="h-1 bg-blue-400 w-2/3 rounded" />
  //       <div className="h-1 bg-blue-400 w-1/2 rounded ml-8" />
  //       <div className="h-1 bg-blue-400 w-2/3 rounded" />
  //       <div className="h-1 bg-blue-400 w-1/3 rounded ml-16" />
  //     </div>
  //     <img
  //       src="/your-assets/plane-passport-globe.png"
  //       alt="Plane, Passport, Globe"
  //       className="w-40 mb-6 mx-auto"
  //     />
  //   </div>
  //   <div>
  //     <img
  //       src="/your-assets/statue-liberty-map.png"
  //       alt="Statue of Liberty, Passport, US Flag"
  //       className="w-40 mb-6 mx-auto"
  //     />

  //     <h2 className="text-xl font-semibold mb-1">
  //       Our Awards <span className="text-red-600">& Achievements</span>
  //     </h2>
  //     <p className="text-gray-500 text-sm mb-3">
  //       Proud moments and recognition for our exceptional service over the
  //       years.
  //     </p>
  //     <ul className="text-sm space-y-1">
  //       <li>
  //         <span className="font-bold text-red-600">2011</span> - Pioneer Award:
  //         Envoys Award
  //       </li>
  //       <li>
  //         <span className="font-bold text-red-600">2013</span> - Excellence in
  //         Gulf Businessman Award
  //       </li>
  //       <li>
  //         <span className="font-bold text-red-600">2014</span> - Gulfstream
  //         Achievement Award (Dubai)
  //       </li>
  //       <li>
  //         <span className="font-bold text-red-600">2016</span> - Pioneer Award:
  //         Homemakers Promotion
  //       </li>
  //       <li>
  //         <span className="font-bold text-red-600">2018</span> - S.S.B.
  //         Bestseller Salon Author National Award
  //       </li>
  //     </ul>
  //   </div>
  // </section>
  <section className="font-manrope max-w-7xl mx-auto lg:px-8 md:px-12 px-4 md:py-16 py-10">
    <div className=" lg:gap-12 md:gap-[60px] grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
      <div className="lg:max-w-xl">
        <h2 className="max-w-md xl:text-5xl md:text-4xl text-3xl font-extrabold  md:mb-6 tracking-wide leading-tight">
          <span className="text-[#0E313A]">Our Journey</span>{" "}
          <span className="text-[#C40808]">Since 1992</span>
        </h2>
        <p className="md:mt-6 mt-3 text-[#666666] text-[16px] leading-7 font-medium">
          Since our founding in 1992, Nisa Travel Agency has been committed to
          transforming aspirations into achievements. What began as a modest
          initiative to guide hardworking Indians toward overseas opportunities
          has grown into a trusted institution, recognized by the Ministry of
          External Affairs, Government of India
        </p>
        <p className="md:mt-6 mt-3 text-[#666666] text-[16px] leading-7 font-medium">
          From our headquarters in New Delhi, we steadily expanded our reach to
          key cities across India, ensuring that opportunities are accessible to
          families everywhere. Over the past three decades, we have successfully
          conducted more than 7,000 recruitment drives, each one representing a
          new chapter of hope and progress for countless individuals and their
          families.
        </p>
      </div>
      <div className="flex justify-center items-center">
        <img
          src={journeyImg}
          alt="Overseas Journey Globe"
          className="w-[400px] h-auto"
        />
      </div>
    </div>
    <div className="pt-12 lg:gap-12 md:gap-[60px] grid grid-cols-1 lg:grid-cols-2 gap-10 items-center ">
      <div className="flex flex-col xl:w-[90%] lg:order-1 order-2 ">
        <img
          src={journeyImg2}
          alt="Overseas Journey Globe"
          className=" lg:h-auto md:h-[700px] h-80"
        />
        <p className="md:mt-6 mt-3 text-[#666666] text-[16px] leading-7 font-medium">
          At Nisa Travel Agency, our story is built on trust, perseverance, and
          a promise that continues to guide us: to be the bridge between dreams
          and destinations.
        </p>
      </div>
      <div className="lg:max-w-xl lg:order-2 order-1">
        <h2 className="max-w-md xl:text-5xl md:text-4xl text-3xl font-extrabold  md:mb-6 tracking-wide leading-tight">
          <span className="text-[#0E313A]">Our Awards</span>{" "}
          <span className="text-[#C40808]">& Achievements</span>
        </h2>
        <p className="md:mt-6 mt-3 text-[#666666] text-[16px] leading-7 font-medium">
          These milestones reflect not only our dedication to ethical
          recruitment but also our unwavering commitment to the welfare of the
          Indian workforce abroad.
        </p>
        <div className="p-6 max-w-md bg-white">
          <ul className="relative">
            {awards.map((award, idx) => (
              <li key={idx} className="pl-8 mb-8 last:mb-0 relative">
                {/* Dot & line */}
                <span className="absolute left-0 top-1.5 flex flex-col items-center">
                 <div className="flex items-center justify-center border-2 border-[#0E313A] rounded-full shadow p-[3px]">
                   <span className=" w-[9px] h-[9px] bg-[#C40808] rounded-full "></span>
                 </div>
                  {idx < awards.length - 1 && (
                    <span className="block w-[2px] h-[110px] bg-[#002661] mx-auto" />
                  )}
                </span>
                {/* Year and title */}
                <span className="block text-xl font-extrabold text-[#C40808]">
                  {award.year}
                </span>
                <span className="block font-extrabold text-[#0E313A]">
                  {award.title}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);
